import { Pipe, PipeTransform } from '@angular/core';
import { Params } from '@angular/router';

import { customFilterParams } from '../product-filter.config';

/**
 * Get params as array collection, where each facet is represented width it's group key.
 * Usable for knowing the amount of active facets. Also to create a tag for each query param
 * even though it's not a part of the active facets in the filter response.
 * Params that are not a part of facets gets filtered out.
 * Output example: [
 *      ["color.da.keyword", "Blå"],
 *      ["brand.da.keyword", "Lyngby"],
 *      ["brand.da.keyword", "Nordisk Tekstil"],
 *      ["brand.da.keyword", "Royal Copenhagen"]
 * ]
 */
@Pipe({
    name: 'toFacetExposedCollection',
    standalone: true
})
export class ToFacetExposedCollectionPipe implements PipeTransform {
    public paramsToStrip: string[] = [
        'take',
        'from',
        'collectionId',
        'sort',
        'include',
        customFilterParams.storeId,
        customFilterParams.stockQuantity
    ];

    transform(params: Params | null): string[][] {
        if (!params) {
            return [];
        }

        return Object.entries(params)
            .filter(([key, _]) => this.paramsToStrip.indexOf(key) === -1)
            .flatMap(([key, val]) => (Array.isArray(val) ? val.map((value: string) => [key, value]) : [[key, val]]));
    }
}
